import Footer from '../footer'
import LanguageSwitch from '../LanguageSwitch'
import Link from 'next/link'
import Image from 'next/future/image'

export default function SimpleLayout ({ children, variant }) {
  return (
    <>
      <header>
        <nav className={`navbar navbar-expand-lg bg-${variant}`}>
          <div className="container">
            <Link href="/">
              <a className="navbar-brand">
                <Image
                  alt=""
                  src="/images/logo.svg"
                  width={150}
                  height={30}
                />
              </a>
            </Link>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#header"
              aria-controls="header"
              aria-expanded="false"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div
              className={`collapse navbar-collapse row w-100 bg-${variant}`}
              id="header"
            >
            </div>
          </div>
        </nav>
      </header>
      <main>{children}</main>
      <Footer />
      <LanguageSwitch />
    </>
  )
}
